import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col, DropdownButton, MenuItem, Modal } from 'react-bootstrap';
import { withFormik } from 'formik';
import { toastr } from 'react-redux-toastr';
import _ from 'lodash';
import Button from './Button';
import ConfirmDialog from './ConfirmDialog';
import TextEditor, { addPlaceholdersHighlight, removePlaceholdersHighlight, replaceValuesWithPlaceholders } from './TextEditor';
import TextInput from './TextInput';
import AutoComplete from './AutoComplete';
import EditTypesDialog from './EditTypesDialog';
import FormField from './FormField';
import { userEmailTemplatesUpdateAction,
         userEmailIntegratedSendAction,
         userEmailIntegratedAction,
         userEmailIntegrationDeleteAction,
         userLogInLoadAction, 
         userDownloadFile,
         userGetConfigAction
} from '../../actions/userActions';

import { caseSetServerError,
         caseEmailAddAction,
         caseEmailsGetAction,
         caseFilesLoadAction } from '../../actions/caseActions';

import { transformText,
         extractFieldsOptions,
         getExtraData,
         getDownloadPath } from '../../helpers/utils';

import { isEmptyString, isEmptyObject } from '../../validators/formValidators';
import * as validators from '../../validators/formValidators';
import { dialogHeaderFooterBgColor } from '../../helpers/colors';
import TemplatesSelect from './TemplatesSelect';
import { TEMPLATES_CARDS } from '../TemplatesForm';
import { getPubliIntakeLinkForCaseType } from './../../helpers/utils';


export const isEmailIntegrated = user => user && ((user['GmailAccount'] && 'GmailToken') || (user['OutlookAccount'] && 'OutlookToken'))

const DEFAULT_STATE = {
    loading: false,
    templatesLoading: false,
    previewedEmail: {},
    emailPreviewDialogOpen: false,
    tmpSubject: undefined,
    tmpMessage: undefined,
    popup: undefined,
    editTemplatesLabel: '',
    editTemplatesOpen: false,
    editTemplatesOnSave: false,
    initialized: false,
    emailCreationOption: undefined,
};


const updateView = (props, transform, template, setValues = true) => {
    if (!template) {
        template = props.values['TemplateType'];
        if (isEmptyObject(template)) {
            return;
        }
    }

    let subject = template['Subject'] || '';
    let message = template['Message'] || '';
    message = addPlaceholdersHighlight(message, props.config, props.user, props.currentCase);
    if (transform) {
        try {
            subject = transformText(subject,
                props.config,
                props.currentCase,
                props.extraData) || '';

            message = transformText(message,
                props.config,
                props.currentCase,
                props.extraData);

        } catch (error) {
            console.error(new Error().stack, error);
            props.dispatch(caseSetServerError(error));
        }
    }

    if (!setValues) {
        return { subject, message };
    }

    props.setFieldValue('Subject', subject);
    props.setFieldValue('Message', message);
}

class SendEmailForm extends PureComponent {
    constructor(props) {
        super(props);
        this.emailAction = this.emailAction.bind(this);
        this.getData = this.getData.bind(this);
        this.submitAction = this.submitAction.bind(this);
        this.saveTemplate = this.saveTemplate.bind(this);
        this.openSaveTemplateDialog = this.openSaveTemplateDialog.bind(this);
        this.getTranslatedEmail = this.getTranslatedEmail.bind(this);
        this.getAttachmentKey = this.getAttachmentKey.bind(this);
        this.onTemplateChange = this.onTemplateChange.bind(this);
        this.templatesUpdateAction = this.templatesUpdateAction.bind(this);
        this.getSelectedTemplateIndex = this.getSelectedTemplateIndex.bind(this);
        this.emailIntegrated = this.emailIntegrated.bind(this);
        this.downloadFile = this.downloadFile.bind(this);
        this.defaultState = {...DEFAULT_STATE};

        this.state = { ... this.defaultState };
    }

    componentWillReceiveProps(nextProps) { 
        const files = nextProps.currentCase.files;
        if (!nextProps.disableCaseFilesAutoload && !files && nextProps.currentCase.id && !nextProps.currentCase._loadingFiles) {
            nextProps.dispatch(caseFilesLoadAction(nextProps.currentCase.id))
                .then((result) => {
                    if (!result) {
                        nextProps.dispatch(caseSetServerError('Cannot load uploaded files - networking error?'));
                        return;
                    }
                })
                .catch((error) => {
                    nextProps.dispatch(caseSetServerError(error));
                });
        }

        if (!this.state.loading &&
            this.props.currentCase &&
            this.props.currentCase.id &&
            !this.props.currentCase.emails &&
            !this.props.currentCase._loadingEmails) {

            this.setState({ loading: true });
            this.props.dispatch(caseEmailsGetAction(this.props.currentCase.id))
                .then((result) => {
                    this.setState({ loading: false });
                })
                .catch((error) => {
                    console.error(new Error().stack, error);
                    this.props.dispatch(caseSetServerError(error));
                });
        }
    }

    emailIntegrated() {
        return isEmailIntegrated(this.props.values['EmailFrom']?.user);
    }

    downloadFile(option) {
        this.props.dispatch(userDownloadFile(option['$DownloadPath$']));
    }

    async getData(dataArg = {}, fetchCorrectSignature = false) {
        const data = { ...this.props.values, ...dataArg };
        const email = await this.getTranslatedEmail(data, fetchCorrectSignature);
        if (_.isArray(data['EmailTo'])) {
            email['EmailTo'] = data['EmailTo'].filter(v => !!v).map(v => {
                if (_.isString(v)) {
                    return v;
                }
                return v.value;
            });
        } else if (_.isObject(data['EmailTo'])) {
            email['EmailTo'] = [data['EmailTo'].value];
        }

        if (data['EmailFrom'] && _.isNumber(data['EmailFrom'])) {
            email['EmailFrom'] = data['EmailFrom'];
        } else {
            email['EmailFrom'] = data['EmailFrom']?.value;
        }
        email['TemplateType'] = data['TemplateType'];
        email['TemplateAttachments'] = [];
        email['FileAttachments'] = [];
        for (let i = 0; this.props.values['SelectedAttachments'] && i < this.props.values['SelectedAttachments'].length; i++) {
            const attachment = this.props.values['SelectedAttachments'][i];
            email['FileAttachments'].push(attachment);

            // if (!isEmptyString(attachment['TemplateName'])) {
            //     email['TemplateAttachments'].push(attachment);

            // } else if (!isEmptyString(attachment['FileName']) &&
            //            !isEmptyString(attachment['UploadType'])) {

            //     email['FileAttachments'].push(attachment);
            // }
        };

        email['CaseId'] = this.props.currentCase.id;
        email['TemplateTypeId'] = this.props.templatesFieldName;
        email['$TokenName$'] = data['$TokenName$'];
        return email;
    }

    async emailAction(data) {
        if (this.state.popup) {
            try {
                popup.focus();
            } catch (error) {}
        }

        if (this.emailIntegrated()) {
            if (this.props.renderEmailButtonOnly) {
                this.setState({ loading: true });
                this.props.dispatch(userEmailIntegrationDeleteAction())
                    .then(() => {
                        this.setState({ loading: false });
                    })
                    .catch((error) => {
                        this.setState({ loading: false });
                        console.error(new Error().stack, error);
                        this.props.dispatch(caseSetServerError(error));
                    });

                return;
            }

            const emailTo = data['EmailTo'];
            if (!emailTo) {
                return;
            }

            if (!emailTo[0] && !emailTo.value) {
                return;
            }

            const totalKbSize = (this.props.values['SelectedAttachments'] || []).reduce((acc, current) => acc + parseFloat(current['$Size$']), 0);
            if (totalKbSize >= 3000.0 && this.props.user['OutlookAccount']) {
                this.props.dispatch(caseSetServerError("Cannot send attachments > 3 MB via Outlook."));
                return;
            }

            if (totalKbSize >= 19000.0) {
                this.props.dispatch(caseSetServerError("Attachments cannot exceed 19 MB."));
                return;
            }

            this.setState({ loading: true });
        }

        const email = await this.getData(data, true);
        email['Message'] = removePlaceholdersHighlight(email['Message']);
        const cleanup = () => {
            this.props.resetForm();
            this.setState({ ...DEFAULT_STATE });
        };

        this.props.dispatch(userEmailIntegratedSendAction(email))
            .then((result) => {
                if (!result) {
                    cleanup();
                    console.error('Sending email failed.');
                    this.props.dispatch(caseSetServerError('Sending email failed.'));
                    return;
                }

                const popupBlockedError = () => {
                    cleanup();
                    this.props.dispatch(userEmailIntegratedAction(false, email['$TokenName$']));
                    this.props.dispatch(caseSetServerError('Please allow popup windows to sign in.\nThere is typically an icon in the address bar\nwhere you can click to enable the popup.'));
                };

                switch (result.data.type) {
                case 'AUTHORIZATION': {
                    const startAuthorization = (authUrl) => {
                    const popup = window.open(authUrl, 'popup', 'toolbar=0,status=0,width=500,height=500');
                        if(!popup || popup.closed || typeof popup.closed == 'undefined') {
                             popupBlockedError();
    
                        } else {
                            this.setState({ popup });
                            try {
                                popup.focus();
                                const toastrOptions = {
                                    timeOut: 15000, // by setting to 0 it will prevent the auto close
                                    showCloseButton: true, // true by default
                                    removeOnHover: true,
                                    progressBar: true,
                                };
    
                                const success = () => {
                                    clearInterval(timer);
                                        popup.close();
                                        cleanup();
                                        this.props.dispatch(userEmailIntegratedAction(true, email['$TokenName$']));
                                        toastr.success('Success', 'Email successfully integrated. Please send your email again.', toastrOptions)
                                };
    
                                const error = () => {
                                    clearInterval(timer);
                                    cleanup();
                                    toastr.error('Authentication', 'You need to authenticate before you can send emails.', toastrOptions)
                                };
    
                                let timer = setInterval(() =>
                                {
                                    if (popup.closed) {
                                        this.props.dispatch(userLogInLoadAction())
                                            .then((result) => {
                                                if (!result) {
                                                    error();
                                                    return;
                                                }
    
                                                const user = result.data.user;
                                                if (user['GmailAccount'] || user['OutlookAccount']) {
                                                    success();
    
                                                } else {
                                                    error();
                                                    return;
                                                }
    
                                            }).catch((error) => {
                                                error();
                                            });
    
                                    } else {
                                        this.props.dispatch(userLogInLoadAction())
                                            .then((result) => {
                                                if (!result) {
                                                    return;
                                                }
    
                                                const user = result.data.user;
                                                if (user['GmailAccount'] || user['OutlookAccount']) {
                                                    success();
                                                }
    
                                            }).catch((error) => {
                                                console.error(new Error().stack, error);
                                            });
                                    }
                                },
                                2000);
    
                            } catch(error) {
                                popupBlockedError();
                            }
                        }
    
                    };

                    if (result.data.authUrlWithRead) {
                        // Ask first whether replies may be read (the popup must open from the click on the answer).
                        this.setState({
                            readChoice: {
                                start: startAuthorization,
                                authUrl: result.data.authUrl,
                                authUrlWithRead: result.data.authUrlWithRead,
                                abort: cleanup,
                            },
                        });
                    } else {
                        startAuthorization(result.data.authUrl);
                    }

                    break;
                }

                case 'SUCCESS':
                    cleanup();
                    this.props.dispatch(caseEmailAddAction(this.props.currentCase.id,
                                                           result.data.email));

                    if (this.props.onEmailSent) {
                        this.props.onEmailSent(result.data.email);
                    }

                    break;

                default:
                    cleanup();
                    console.error(result);
                    this.props.dispatch(caseSetServerError('Invalid email result type!'));
                    break;
                }

            })
            .catch((error) => {
                cleanup();
                console.error(new Error().stack, error);
                this.props.dispatch(caseSetServerError(error));
            });
    }

    onTemplateChange(selected) {
        if (!selected) {
            selected = { label: '', type: '', value: '' };
        }

        if (selected.Name && (!selected.label || !selected.value)) {
            selected.label = selected.Name;
            selected.value = selected.Name;
            selected.type = selected.Name;
        }

        this.props.setFieldValue('TemplateType', selected);
        const transform = !this.props.doNotTransform && !this.props.renderTemplateLoad;
        let props = this.props;
        // Sharing Intake Form - inject proper extra.PublicIntakeLink to point to currently selected template.
        if (selected['$TemplatesFieldName$'] === 'publicIntakeEmailTemplates' && (!this.props.currentCase || !this.props.currentCase.publicIntakeHash)) {
            props = {...this.props};
            let extraData = {...this.props.extraData};
            extraData['extra.PublicIntakeLink'] = getPubliIntakeLinkForCaseType(selected.value, this.props.user);
            props.extraData = extraData;
        }
        updateView(props, transform, selected);
    }

    templatesUpdateAction(templates) {
        return userEmailTemplatesUpdateAction(templates.filter(template => template.type !== ''),
                                              this.props.templatesFieldName);
    }

    getSelectedTemplateIndex() {
        if (!this.props.values['TemplateType'] || !this.props.values['TemplateType'].type) {
            return -1;
        }

        const index = this.props.templates.findIndex(value => value.type === this.props.values['TemplateType'].type);
        return index;
    }

    openSaveTemplateDialog(data) {
        this.setState({
            editTemplatesOpen: true,
            editTemplatesLabel: 'Save Email Template As (Select One)',
            editTemplatesOnSave: (selectedIndex, types) => {
                if (selectedIndex < 0) {
                    return;
                }

                this.saveTemplate(data, types, selectedIndex);
            },
        });
    }

    saveTemplate(data, templates, index) {

        //
        // If preview is checked, than the template text is not available.
        // It would replace all the variable placeholders.
        //

        if (templates.length <= index) {
            return;
        }

        templates[index]['Subject'] = data['Subject'];
        templates[index]['Message'] = replaceValuesWithPlaceholders(data['Message']);
        this.setState({ templatesLoading: true });
        this.props.dispatch(this.templatesUpdateAction(templates))
            .then((result) => {
                if (result) {
                    this.setState({
                        templatesLoading: false,
                        editTemplatesOpen: false,
                        editTemplatesOnSave: false,
                    });

                } else {
                    console.error('No data received');
                    this.setState({
                       templatesLoading: false,
                    });

                    this.props.dispatch(caseSetServerError('No data received'));
                }
            })
            .catch((error) => {
                console.error(new Error().stack, error);
                this.setState({
                    templatesLoading: false,
                });

                this.props.dispatch(caseSetServerError(error));
            });
    }

    async getTranslatedEmail(data, ensureCorrectSignature = false) {
        let subject = data['Subject'];
        let message = data['Message'];
        if (!this.props.doNotTransform) {
            let signature = this.props.config['emailSignature'];
            if (ensureCorrectSignature && this.props.values['EmailFrom']?.user.id !== this.props.user?.id) {
                try {
                    const config = await this.props.dispatch(userGetConfigAction(this.props.values['EmailFrom'].user.id));
                    signature = config?.data['emailSignature'];
                } catch (error) {
                    console.error(new Error().stack, error);
                    this.props.dispatch(caseSetServerError('Cannot fetch users email signature!'));
                }
            }
            if (!isEmptyString(signature)) {
                message += '\n\n';
                message += signature;
            }

            try {
                subject = transformText(subject,
                                        this.props.config,
                                        this.props.currentCase,
                                        this.props.extraData);

                message = transformText(message,
                                        this.props.config,
                                        this.props.currentCase,
                                        this.props.extraData);

            } catch (error) {
                console.error(new Error().stack, error);
            }
        }

        return {
            'Subject': subject,
            'Message': message,
        };
    }

    submitAction(data) {
        switch(data['_ButtonType_']) {
        case 'emailAction':
            this.emailAction(data);
            break;

        case 'saveTemplate':
            this.openSaveTemplateDialog(data);
            break;

        default:
            break;
        }
    }

    getAttachmentKey(index) {
        const key = 'attachment_' + index;
        return key;
    }

    render() {
        const {
            sortedEmails,
            config,
            isSubmitting,
            handleSubmit,
            user,
            currentCase,
            values,
            handleChange,
            handleBlur,
            errors,
            touched,
            setFieldValue,
            open,
            cancel,
            title,
            templateEditor,
            templatesFieldName,
            enableAddTemplate = true,
            enableEditTemplate = true,
        } = this.props;

        let {
            renderTemplateLoad,
            renderEmailSection,
            renderEmailButton,
            renderAsRegularForm = false,
            renderAttachmentField = true,
        } = this.props;

        let onChange;
        if (this.props.onChange) {
            onChange = async(evt) => {
                const data = {};
                if (_.isArray(evt)) {
                    if (evt.length > 0) {
                        data[evt[0].fieldName] = evt;
                    }
                } else if (_.isObject(evt)) {
                    if (evt.target) {
                        data[evt.target.name] = evt.target.value;
                    } else {
                        data[evt.fieldName] = evt.value;
                    }
                } 

                const emailObj = await this.getData(data);
                this.props.onChange(emailObj);
            };
        }

        if (renderEmailButton === undefined) {
            renderEmailButton = true;
        }

        const templatesLoading = this.state.templatesLoading;
        const loading = this.state.loading || templatesLoading || !!this.props.loading;
        const onSubmitClick = (data) => {
            this.submitAction(data);
        };

        let emailActionLabel = '';
        const disableEmailBtn = (isEmptyString(values['EmailTo']) ||
                                 isEmptyString(values['Subject']) ||
                                 isEmptyString(values['Message'])) &&
                                 !this.props.renderEmailButtonOnly &&
                                 this.emailIntegrated();

        let emailButton = '';
        const emailButtonDisabled = loading ||
                                  isSubmitting ||
                                  this.state.popup ||
                                  disableEmailBtn;

        const emailBtnBsStyle = this.props.renderEmailButtonBsStyle || 'primary';
        const emailBtnStyle = { ...this.props.renderEmailButtonStyle };
        switch (this.emailIntegrated()) {
        case 'GmailToken':
            if (this.props.renderEmailButtonOnly) {
                emailActionLabel = 'Disconnect GMail';
            } else {
                emailActionLabel = 'Send Email';
            }

            emailButton = (
                <Button bsStyle={emailBtnBsStyle}
                        label={emailActionLabel}
                        style={emailBtnStyle}
                        img="/img/gmail_icon.png"
                        imgStyle={{ height: '20px' }}
                        loading={!!loading}
                        disabled={!!emailButtonDisabled}
                        loadingLabel="Processing ..."
                        onClick={() => onSubmitClick({ ...values, '$TokenName$': 'GmailToken', _ButtonType_: 'emailAction' })}/>
            );

            break;

        case 'OutlookToken':
            if (this.props.renderEmailButtonOnly) {
                emailActionLabel = 'Disconnect Outlook';
            } else {
                emailActionLabel = 'Send Email';
            }

            emailButton = (
                <Button bsStyle={emailBtnBsStyle}
                        label={emailActionLabel}
                        style={emailBtnStyle}
                        img="/img/outlook_email_icon.png"
                        imgStyle={{ height: '20px' }}
                        loading={loading}
                        disabled={emailButtonDisabled}
                        loadingLabel="Processing ..."
                        onClick={() => onSubmitClick({ ...values, '$TokenName$': 'OutlookToken', _ButtonType_: 'emailAction' })}/>
            );

            break;

        default:
            emailButton = (
                <React.Fragment>
                    <Button
                        label=' GMail'
                        disabled={emailButtonDisabled}
                        img='/img/gmail_icon.png'
                        imgStyle={{ height: 20 }}
                        onClick={() => onSubmitClick({ ...values, '$TokenName$': 'GmailToken', _ButtonType_: 'emailAction' })}
                    />
                    <Button 
                        label=' Outlook'
                        disabled={emailButtonDisabled}
                        img='/img/outlook_email_icon.png'
                        imgStyle={{ height: 20 }}
                        onClick={() => onSubmitClick({ ...values, '$TokenName$': 'OutlookToken', _ButtonType_: 'emailAction' })}
                    />
                </React.Fragment>);

            break;
        }

        let emailTemplateButton = (
            <Button label="Save As Template"
                    icon="floppy-disk"
                    loading={isSubmitting}
                    disabled={loading ||
                            isSubmitting ||
                            isEmptyString(values['Subject']) ||
                            isEmptyString(values['Message']) ||
                            this.state.previewChecked}
                    onClick={() => onSubmitClick({ ...values, _ButtonType_: 'saveTemplate' })}
                    tooltip="Opens dialog to select template name under which subject and message will be saved"
            />
        );

        const readChoice = this.state.readChoice;
        const readChoiceDialog = (
            <ConfirmDialog title="Read replies to your emails?"
                           open={!!readChoice}
                           cancel={() => {
                               const choice = this.state.readChoice;
                               this.setState({ readChoice: undefined });
                               if (choice && choice.abort) {
                                   choice.abort();
                               }
                           }}
                           confirmButton={readChoice && (
                               <React.Fragment>
                               <Button label="Not now"
                                       onClick={() => {
                                           this.setState({ readChoice: undefined });
                                           readChoice.start(readChoice.authUrl);
                                       }}/>
                               <Button label="Yes, allow"
                                       bsStyle="primary"
                                       icon="ok"
                                       style={{ marginLeft: 10 }}
                                       onClick={() => {
                                           this.setState({ readChoice: undefined });
                                           readChoice.start(readChoice.authUrlWithRead);
                                       }}/>
                               </React.Fragment>)}>
                <p>Do you want Case Tempo to also read the replies to emails that you send from Case Tempo?</p>
                <ul>
                    <li>You will see the whole conversation on the case, with its attachments.</li>
                    <li>Attachments can be saved to the case documents with one click.</li>
                    <li>Only conversations of emails sent from Case Tempo are read, nothing else in your mailbox.</li>
                    <li>You can change this any time with "Read email conversations" in your profile.</li>
                </ul>
            </ConfirmDialog>
        );

        if (this.props.renderEmailButtonOnly) {
            return (
                <FormField>
                <form onSubmit={handleSubmit}>
                {emailButton}
                </form>
                {readChoiceDialog}
                </FormField>
            );
        }

        let mdWidth = renderAsRegularForm ? 5 : 6;
        if (this.props.maxWidth) {
            mdWidth = 12;
        }
        const templateLoadComponent = (
            <TemplatesSelect
                label="Use Template"
                field={{
                    name: 'TemplateType',
                    onChange: this.onTemplateChange,
                    onBlur: handleBlur,
                    error: errors['TemplateType'],
                    touched: touched['TemplateType'],
                    value: values['TemplateType'].type,
                }}
                templatesFieldName={templatesFieldName}
                enabledDocuments={TEMPLATES_CARDS.filter(v => v.value === 'email_templates')}
            />
        );

        let sendEmailComponent = '';
        if (renderEmailSection) {
            sendEmailComponent = (
                <div>
                {!renderTemplateLoad && (
                <React.Fragment>
                {!this.props.disableEmailFrom && this.props.emailFromUsers && this.props.emailFromUsers.length > 1 && (
                <Row>
                    <Col xs={12} md={mdWidth}>
                        <AutoComplete field={{
                                          name: 'EmailFrom',
                                          onChange: value => setFieldValue('EmailFrom', value),
                                          onBlur: handleBlur,
                                          error: errors['EmailFrom'],
                                          touched: touched['EmailFrom'],
                                          value: values['EmailFrom'],
                                      }}
                                      returnSelectedObject
                                      isClearable={false}
                                      label="Email From"
                                      onChange={onChange}
                                      disabled={isSubmitting || loading}
                                      autosize
                                      options={this.props.emailFromUsers}/>
                    </Col>
                </Row>)}
                {!this.props.disableEmailFrom && !(this.props.emailFromUsers && this.props.emailFromUsers.length > 1) && values['EmailFrom'] && values['EmailFrom'].user && values['EmailFrom'].user['MailboxAddress'] && (
                <Row>
                    <Col xs={12} md={mdWidth}>
                        <div className="ct-sending-from">Sending from <strong>{values['EmailFrom'].user['MailboxAddress']}</strong></div>
                    </Col>
                </Row>)}
                <Row>
                    <Col xs={12} md={mdWidth}>
                        <AutoComplete field={{
                                          name: 'EmailTo',
                                          onChange: value => setFieldValue('EmailTo', value),
                                          onBlur: handleBlur,
                                          error: errors['EmailTo'],
                                          touched: touched['EmailTo'],
                                          value: values['EmailTo'],
                                      }}
                                      returnSelectedObject
                                      label="Email To"
                                      onChange={onChange}
                                      disabled={isSubmitting || loading}
                                      autosize
                                      allowNew
                                      multiselect
                                      options={sortedEmails}/>
                    </Col>
                </Row>
                </React.Fragment>)}
                <Row>
                    <Col xs={12} md={mdWidth}>
                        <TextInput field={{
                                       name: 'Subject',
                                       onChange: handleChange,
                                       onBlur: handleBlur,
                                       error: errors['Subject'],
                                       touched: touched['Subject'],
                                       value: values['Subject'],
                                   }}
                                   label="Subject"
                                   onChange={onChange}
                                   disabled={isSubmitting || loading || this.state.previewChecked}
                                   loading={loading}
                        />
                    </Col>
                </Row>
                {(!renderTemplateLoad && renderAttachmentField) && (
                <Row>
                    <Col xs={12} md={mdWidth}>
                        <TemplatesSelect
                            field={{
                                name: 'attachment',
                                touched: true,
                                value: this.props.values['SelectedAttachments'],
                                onChange: fileName => { 
                                    if (!fileName) {
                                        this.props.setFieldValue('SelectedAttachments', []);
                                        if (onChange) {
                                            onChange();
                                        }
                                        return;
                                    }

                                    const convertToAttachment = (name, size = 0, type, downloadPath) => {
                                        return {
                                            'label': name,
                                            'value': name,
                                            'Label': name,
                                            'FileName': name,
                                            '$Size$': size,
                                            'CaseId': this.props.currentCase.id,
                                            'UploadType': type,
                                            '$DownloadPath$': downloadPath,
                                        };
                                    };

                                    if (_.isArray(fileName)) {
                                        this.props.setFieldValue('SelectedAttachments', fileName.map(v => convertToAttachment(v['FileName'], v['$Size$'], v['$Subfolder$'], v['$DownloadPath$'])));
                                        if (onChange) {
                                            onChange();
                                        }

                                        return;
                                    }

                                    let size = 0;
                                    let downloadPath = undefined;
                                    let type = 'notes';
                                    if (_.isObject(fileName)) {
                                        size = fileName['$Size$'];
                                        downloadPath = fileName['$DownloadPath$'];
                                        type = fileName['$Subfolder$'];
                                        fileName = fileName['Name'];
                                    } else {
                                        downloadPath = getDownloadPath(this.props.currentCase.id, fileName, type);
                                    }
                                
                                    const attachment = convertToAttachment(fileName, size, type, downloadPath);
                                    const attachments = this.props.values['SelectedAttachments'] || [];
                                    if (!attachments.find(v => v['FileName'] === fileName)) {
                                        attachments.push(attachment);
                                    }

                                    this.props.setFieldValue('SelectedAttachments', attachments);
                                    if (onChange) {
                                        onChange();
                                    }
                                }}}
                            multiselect
                            uploadDocTemplateOnSelect
                            label="Attachments"
                            onValueClick={this.downloadFile}
                            enabledDocuments={TEMPLATES_CARDS.filter(v => v.value === 'documents' || v.value === 'doc_templates')}
                        />
                    </Col>
                </Row>)}
                <Row>
                    <Col xs={12}>
                        <TextEditor field={{
                                        name: 'Message',
                                        onChange: (value) => { setFieldValue('Message', value); },
                                        error: errors['Message'],
                                        touched: touched['Message'],
                                        value: values['Message'],
                                    }} 
                                    label="Message"
                                    onChange={onChange}
                                    rows={4}
                                    disabled={isSubmitting || loading || this.state.previewChecked}
                                    loading={loading}
                                    isEmail
                                    fullSize={!renderAsRegularForm}
                                    currentConfig={config}
                                    currentCase={currentCase}
                                    loggedIn={user} />
                    </Col>
                </Row>
                {!this.props.showAsDialog && (
                <Row style={{ float: 'right' }}>
                <Col xs={12}>
                {renderEmailButton && emailButton}
                </Col>
                </Row>)}
                </div>
            );
        }

        const emailForm = (
            <form onSubmit={handleSubmit}>
                {!this.props.showAsDialog && templateLoadComponent}
                {sendEmailComponent}
                {!this.props.showAsDialog && renderTemplateLoad && (
                    <Row style={{ float: 'right' }}>
                        <Col xs={12}>
                        {emailTemplateButton}
                        </Col>
                    </Row>
                )}
                <EditTypesDialog types={this.props.templates}
                                 defaultType={{ type: 'New' }}
                                 open={this.state.editTemplatesOpen}
                                 onClose={() => {
                                     this.setState({ editTemplatesOpen: false, editTemplatesOnSave: false });
                                 }}
                                 label={this.state.editTemplatesLabel}
                                 onSave={this.state.editTemplatesOnSave}
                                 defaultSelectedIndex={this.getSelectedTemplateIndex()}
                                 typeLabel="Selected Template"
                                 loading={this.props.templates === undefined}
                                 modificationDisabled={(types, index) => index === -1}
                                 dispatchSaveAction={this.templatesUpdateAction}
                                 enableAdd={enableAddTemplate}
                                 enableEdit={enableEditTemplate}
                                 enableDelete={enableEditTemplate}
                />
            </form>
        );

        if (!this.props.showAsDialog) {
            return (<React.Fragment>{emailForm}{readChoiceDialog}</React.Fragment>);
        }

        return (
            <Modal show={open}
                   backdrop='static'
                   onHide={() => {
                       this.props.resetForm();
                       this.setState({ ...DEFAULT_STATE }, () => { 
                            if (onChange) {
                                onChange();
                            }
                       });

                       if (sortedEmails.length > 0) {
                           let initialEmailTo = sortedEmails.find(s => s['$TableName$'] === 'client' && s['name'] === 'Email') || sortedEmails[0];
                           setFieldValue('EmailTo', initialEmailTo);
                       }

                       cancel();
                   }}
                   dialogClassName="modal-dialog-full ct-email-dialog">
                <Modal.Header closeButton style={{ backgroundColor: dialogHeaderFooterBgColor }}>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Row>
                    <Col xs={12} md={mdWidth}>
                    {templateLoadComponent}
                    </Col>
                </Row>
                {emailForm}
                {readChoiceDialog}
                </Modal.Body>
                <Modal.Footer style={{ backgroundColor: dialogHeaderFooterBgColor }}>
                <div>
                {templateEditor ? (
                    <div style={{ float: 'right' }}>{emailTemplateButton}</div>    
                ) : (
                    <div>
                    <div style={{ float: 'left' }}>{emailTemplateButton}</div>
                    <div style={{ float: 'right' }}>{emailButton}</div>
                    </div>
                )}
                </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

SendEmailForm.propTypes = {
    templatesFieldName: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    onEmailSent: PropTypes.func,
    onChange: PropTypes.func,
    initialEmail: PropTypes.object,
    initialTemplate: PropTypes.object,
    doNotTransform: PropTypes.bool,
    renderEmailButtonOnly: PropTypes.bool,
    renderEmailButtonBsStyle: PropTypes.string,
    renderTemplateLoad: PropTypes.bool,
    renderEmailSection: PropTypes.bool,
    renderEmailSendButton: PropTypes.bool,
    renderEmailButton: PropTypes.bool,
    renderAttachmentField: PropTypes.bool,
    renderAsRegularForm: PropTypes.bool,
    extraPlaceholders: PropTypes.object,
    enableAddTemplate: PropTypes.bool,
    enableEditTemplate: PropTypes.bool,
    
    // for the dialog
    showAsDialog: PropTypes.bool,
    title: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    cancel: PropTypes.func.isRequired,
    templateEditor: PropTypes.bool,
    disableCaseFilesAutoload: PropTypes.bool,
    disableEmailFrom: PropTypes.bool
};


const getEmails = (config, currentCase, doNotTransform) => {
    let emails = [];
    if (!isEmptyObject(config) && !isEmptyObject(currentCase)) {
        emails = extractFieldsOptions(config, currentCase, 'Email');
    }

    if (doNotTransform) {
        const email = { label: 'Current Client: {client.Email}', value: '{client.Email}' };
        emails = [email];
    }

    emails = emails.map(e => ({...e, fieldName: 'EmailTo' }));
    return emails;
};

const mapStateToProps = (state, ownProps) => {
    const config = state.user.config;
    let currentCase = ownProps.currentCase;
    if (isEmptyObject(currentCase)) {
        currentCase = state.cases.current;
    }
    const emails = getEmails(config, currentCase, ownProps.doNotTransform);
    let initialEmailTo;
    let templates = [];
    if (config && config[ownProps.templatesFieldName]) {
        templates = config[ownProps.templatesFieldName];
    }

    let initialValues = {};
    if (emails.length > 0) {
        initialEmailTo = emails.find(s => s['$TableName$'] === 'client' && s['name'] === 'Email') || emails[0];
    }

    const user = state.user.loggedIn;
    let extraData = getExtraData(currentCase, config, user);
    if (ownProps.extraPlaceholders) {
        extraData = { ...extraData, ...ownProps.extraPlaceholders };
    }

    const emailFromUsers = (state.user.employees && state.user.employees.filter(e => !!isEmailIntegrated(e) && e.id !== user?.id).map(e => ({
        // The address mail really leaves from: the connected Gmail / Outlook mailbox, not the Case Tempo login.
        label: `${e['FirstName']} ${e['LastName']} <${e['MailboxAddress'] || e['Email']}>`,
        value: e.id,
        user: e,
        fieldName: 'EmailFrom'
    }))) || [];

    let emailFrom = undefined;
    if (user) {
        emailFrom = {
            label: `${user['FirstName']} ${user['LastName']} <${user['MailboxAddress'] || user['Email']}>`,
            value: user.id,
            user,
            fieldName: 'EmailFrom'
        };

        emailFromUsers.splice(0, 0, emailFrom);
    }

    const props = {
        currentCase,
        config,
        user,
        emailFromUsers,
        templates,
        sortedEmails: emails,
        initialValues,
        extraData,
        enableEditTemplate: ownProps.enableEditTemplate,
        enableAddTemplate: ownProps.enableAddTemplate,
    };

    if (ownProps.initialEmail) {
        initialValues = { TemplateType: { label: '', value: '' }, 'EmailFrom': emailFrom, 'EmailTo': initialEmailTo, ...ownProps.initialEmail };
    } else {
        initialValues = { 'EmailFrom': emailFrom, 'EmailTo': initialEmailTo, 'Subject': '', 'Message': '<div></div>' };
        if (!isEmptyObject(ownProps.initialTemplate)) {
            initialValues['TemplateType'] = { 
                ...ownProps.initialTemplate, 
                label: ownProps.initialTemplate.type, 
                value: ownProps.initialTemplate.type
            };
    
            const updatedEmail = updateView(props,
                                            !ownProps.doNotTransform && !ownProps.renderTemplateLoad,
                                            initialValues['TemplateType'],
                                            false);
    
            initialValues['Subject'] = updatedEmail.subject;
            initialValues['Message'] = updatedEmail.message;
        } else {
            initialValues['TemplateType'] = { label: '', value: '' };
        }
    }

    props.initialValues = initialValues;
    return props;
};

const validateSendEmailForm = (values) => {
    let errors = {};
    const subject = values['Subject'];
    const message = values['Message'];

    let error = validators.validateText(subject, 'Subject', 1000);
    errors = { ...errors, ...error };
    error = validators.validateText(message, 'Message', 50000);
    errors = { ...errors, ...error };

    try {
        const subjectText = transformText(subject);

    } catch (error) {
        error = `Subject transformation error: ${error}\n`;
        errors = { ...errors, ...error };
    }

    try {
        const messageText = transformText(message);

    } catch (error) {
        error = `Message transformation error: ${error}\n`;
        errors = { ...errors, ...error };
    }

    return errors;
};

const formikWrapper = {
    mapPropsToValues: props => props.initialValues,
    validate: validateSendEmailForm,
    enableReinitialize: true,
};


export default connect(mapStateToProps)(withFormik(formikWrapper)(SendEmailForm));
